module.exports = __webpack_public_path__ + "assets/Schmerzen.91452fe4.png";